import { Layers } from "appworks/graphics/layers/layers";
import { ControlFactory } from "appworks/ui/factories/control-factory";
import { AgsStopOnFeatureToggleControl } from "../ags-stop-on-feature-toggle-control";

export class AgsStopOnFeatureControlFactory implements ControlFactory {
    public filter(layer: Layers) {
        if (layer.getFlexiToggle("stop_on_feature") && layer.getText("stop_on_feature_label")) {
            return true;
        }

        return false;
    }

    public build(layer: Layers) {
        return [new AgsStopOnFeatureToggleControl(layer.getFlexiToggle("stop_on_feature"), layer.getText("stop_on_feature_label"))];
    }
}
